import { styled } from 'styles/stitches.config'
import { rem } from 'polished'

export const Top = styled('div', {
  position: 'relative',

  '& .chakra-breadcrumb': {
    fontFamily: '$raleway',
    fontWeight: 600,

    fontSize: rem(12),
    color: '$grey600',

    '& li': {
      '&:last-of-type': {
        color: '$emerald500',
      },
    },
  },
})

export const Background = styled('div', {
  width: '100%',
  paddingTop: 60,

  backgroundImage: 'url(/banner_gramas.webp)',
  backgroundSize: 'cover',

  position: 'relative',
})

export const WrapBox = styled('div', {})

export const Box = styled('div', {
  position: 'relative',
  left: '50%',
  marginTop: 90,

  padding: '16px',

  transform: 'translateX(-50%)',
  flexDirection: 'column',

  background: '$white',
  borderRadius: '32px 32px 0 0',
  textAlign: 'center',

  width: '90%',

  '@xl': {
    padding: '16px 90px',
    width: 'auto',
    display: 'inline-flex',
  },
})

export const Category = styled('h1', {
  fontFamily: '$domine',
  fontWeight: 'bold',
  color: '$grey900',
  fontSize: rem(24),

  '@md': {
    fontSize: rem(54),
  },
})

export const CategorySmall = styled('h2', {
  fontFamily: '$raleway',
  fontWeight: ' !important',
  color: '$grey900',
  margin: '16px 0',
  fontSize: `${rem(16)} !important`,
})


export const ScientifcName = styled('h2', {
  fontFamily: '$raleway',
  fontWeight: 'normal !important',
  fontStyle:"italic",
  color: '$grey900',
  margin: '16px 0',
  fontSize: `${rem(16)} !important`,
})

export const Main = styled('main', {
  '& section': {
    paddingTop: 50,
    paddingBottom: 100,
  },
})
